import React, { Component } from 'react';
import { Modal, Select, Button, Input, InputNumber, message, Row, Col } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const Option = Select.Option;

class SettingModal extends Component {
    state = {
        visible: false,
        isEdit: false,
        versionId: undefined,
        versionList: [],
        data: [],
        originalData: {},
        loading: false,
        showRequestMes: false,
    };

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.queryEmpCostVersionList();
        });
    };

    hide = () => {
        this.setState({ 
            visible: false,
            isEdit: false,
            versionId: undefined,
            versionList: [],
            data: [],
            originalData: {},
            loading: false,
            showRequestMes: false,
        });
    };

    queryEmpCostVersionList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEmpCostVersionList,
            data: { versionType: 'TYPE_PARAMETER' },
            dataType: 'json',
            doneResult: res => {
                this.setState({ 
                    versionList: res.datas || [],
                    versionId: res.datas.length > 0 ? res.datas[0].empCostCalculateVersionId : undefined,
                });
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { versionId } = this.state;
        if (!versionId) return;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryParameterDataList,
            data: { versionId },
            dataType: 'json',
            doneResult: res => {
                const datas = res.datas || {};
                this.setState({
                    loading: false,
                    data: datas,
                    originalData: JSON.parse(JSON.stringify(datas)),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    };

    handleVersionChange = (value) => {
        this.setState({ versionId: value }, () => {
            this.loadData();
        });
    };

    handleEdit = () => {
        this.setState({
            isEdit: true,});
    };

    handleCancel = () => {
        const { originalData } = this.state;
        this.setState({
            isEdit: false,
            data: JSON.parse(JSON.stringify(originalData)),
            showRequestMes: false,
        });
    };

    handleSave = () => {
        const { data, versionId } = this.state;

        // 校验必填
        const hasEmptyField = data.some(item => !item.parameterName || !item.parameterValue);
        if(hasEmptyField) {
            this.setState({ showRequestMes: true });
            return;
        };

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateParameterDataList,
            data: {
                parameterList: JSON.stringify(data),
                versionId
            },
            dataType: 'json',
            doneResult: res => {
                message.success('保存成功');
                this.setState({
                    loading: false,
                    isEdit: false,
                    showRequestMes: false,
                });
                this.queryEmpCostVersionList();
                this.props.resetData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    };

    handleInputChange = (value, key, index) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    };

    renderInput = (value, key, index) => {
        const { isEdit, showRequestMes } = this.state;
        if (isEdit) {
            if (key === 'parameterValue') {
                return (
                    <span>
                        <InputNumber
                            precision={2}
                            step={0.01}
                            style={{ width: 100 }}
                            value={value}
                            placeholder="请输入"
                            onChange={val => this.handleInputChange(val, key, index)}
                        /> %
                        {showRequestMes && !value && <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>请输入数值</div>}
                    </span>
                );
            }
            return (
                <span>
                    <Input
                        style={{ width: 120 }}
                        value={value}
                        onChange={e => this.handleInputChange(e.target.value, key, index)}
                        placeholder="请输入"
                    />
                    {showRequestMes && !value && <div style={{ color: 'red', fontSize: '12px', marginTop: '4px', textAlign: 'right', width: 185 }}>请输入名称</div>}
                </span>
            );
        }
        
        return key === 'parameterValue' ? value + '%' : value;
    };

    render() {
        const { visible, loading, data, versionId, versionList, isEdit } = this.state;
        
        return (
            <Modal
                title="参数设置"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
                width={600}
                footer={
                    <div style={{ textAlign: 'center' }}>
                        {isEdit ? (
                            <span>
                                <Button onClick={this.handleCancel} style={{ marginRight: 10 }}>取消</Button>
                                <Button type="primary" onClick={this.handleSave}>确定</Button>
                            </span>
                        ) : (
                            <Button type="primary" onClick={this.handleEdit}>编辑</Button>
                        )}
                    </div>
                }
            >
                <div style={{ marginBottom: 20 }}>
                    <span style={{ marginRight: 10 }}>版本：</span>
                    <Select
                        style={{ width: 200 }}
                        value={versionId}
                        onChange={this.handleVersionChange}
                        placeholder="请选择版本"
                    >
                        {versionList.map(item => (
                                <Option key={item.empCostCalculateVersionId} value={item.empCostCalculateVersionId}>{item.versionNum}</Option>
                            ))}
                    </Select>
                    {
                        versionList.length > 1 && <span style={{ marginLeft: 10 }}>更新时间：{moment(versionList[0].createTime).format('YYYY-MM-DD')}</span>
                    }
                </div>
                
                <div style={{ padding: '0 20px' }}>
                    {data.map((item, index) => {
                            const { sortIndex, lineOfBusinessName, parameterName, parameterValue } = item;
                            return(
                                <Row key={`${index}`} style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around' }}>
                                    <Col span={12} >
                                        <label style={{ width: 120, display: 'inline-block', textAlign: 'right', verticalAlign: 'top' }}>{`参数${sortIndex}${lineOfBusinessName || ''}名称`}：</label>
                                        {this.renderInput(parameterName, 'parameterName', index)}
                                    </Col>
                                    <Col span={8} style={{ paddingLeft: 10 }}>
                                        <div style={{ display: 'inline-block', verticalAlign: 'top' }}>数值：</div>
                                        <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                                            {this.renderInput(parameterValue, 'parameterValue', index)}
                                        </div>
                                    </Col>
                                </Row>
                            )
                        })
                    }
                </div>
            </Modal>
        );
    }
}

export default SettingModal;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/standardVisitPrice/SettingModal.js